import { BlockNotFoundError, } from 'viem';
export async function getBlockStats(client, { blockHash, blockNumber, stats }) {
    const blockHashOrNumber = blockHash || blockNumber;
    if (!blockHashOrNumber) {
        throw new BlockNotFoundError({ blockHash, blockNumber });
    }
    try {
        const params = [
            blockHashOrNumber,
        ];
        if (stats) {
            params.push(stats);
        }
        const data = await client.request({
            method: 'getblockstats',
            params: params,
        }, { dedupe: true });
        return data;
    }
    catch (_error) {
        throw new BlockNotFoundError({ blockHash, blockNumber });
    }
}
//# sourceMappingURL=getBlockStats.js.map